module.exports = __webpack_public_path__ + "static/media/wrench.a402d9f9.svg";